export default "__VITE_ASSET__DmTh78VM__"